import { render } from "./ModalConfirmSubmit.vue?vue&type=template&id=289664b6"
import script from "./ModalConfirmSubmit.vue?vue&type=script&lang=js"
export * from "./ModalConfirmSubmit.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__